export default {
    removeAccents(value) {
        return value.replace(/ș/g, 's').replace(/Ș/g, 'S').replace(/ț/g, 't').replace(/Ț/g, 'T').replace(/ă/g, 'a').replace(/Ă/g, 'A').replace(/å/g, 'a').replace(/Å/g, 'A').replace(/â/g, 'a').replace(/Â/g, 'A').replace(/î/g, 'i').replace(/Î/g, 'I');
    },
};
